export const DEFAULT_AUDIO_MODEL = "groq/whisper-large-v3";

export const AUDIO_MODELS = [
  { id: DEFAULT_AUDIO_MODEL, label: "Whisper v3 (default)" },
  { id: "groq/whisper-large-v3-turbo", label: "Whisper v3 Turbo" },
] as const;

export const AUDIO_LANGUAGES = [
  { id: "auto", label: "Auto-detect" },
  { id: "en", label: "English" },
  { id: "es", label: "Spanish" },
  { id: "fr", label: "French" },
  { id: "de", label: "German" },
  { id: "it", label: "Italian" },
  { id: "pt", label: "Portuguese" },
  { id: "hi-IN", label: "Hindi" },
  { id: "pa-IN", label: "Punjabi" },
  { id: "zh", label: "Chinese" },
  { id: "ja", label: "Japanese" },
  { id: "ko", label: "Korean" },
] as const;

export type AudioModelId = (typeof AUDIO_MODELS)[number]["id"];

export function isSupportedAudioModel(value: string): value is AudioModelId {
  return AUDIO_MODELS.some((model) => model.id === value);
}

export function isSupportedAudioLanguage(value: string): boolean {
  return AUDIO_LANGUAGES.some((language) => language.id === value);
}
